import React from 'react'
import "./footer.css"
import logo from "../../assets/images/logo.png"

const Footer = () => {
  return (
    <div className="section__padding omv__footer">
      <img src={logo} alt="logo" />
      <h2>O-Movies</h2></div>
  )
}

export default Footer